import {
  RETRIEVE_DYNAMICMETADATAS,
  CREATE_DYNAMICMETADATA,
  UPDATE_DYNAMICMETADATA,
  UPDATE_DYNAMICMETADATA_STATUS,
  DELETE_DYNAMICMETADATA,
  RESTORE_DYNAMICMETADATA,
} from "../actions/types";

const initialState = { dynamicMetaDatas: [], totalCount: 0 };

const dynamicMetaDataReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_DYNAMICMETADATAS:
      return {
        dynamicMetaDatas: payload.rows,
        totalCount: payload.count,
      };

    case CREATE_DYNAMICMETADATA:
      return payload;

    case UPDATE_DYNAMICMETADATA:
      return payload;

    case UPDATE_DYNAMICMETADATA_STATUS:
      return {
        dynamicMetaDatas: payload.rows,
        totalCount: payload.count,
      };

    case DELETE_DYNAMICMETADATA:
      return {
        dynamicMetaDatas: payload.rows,
        totalCount: payload.count,
      };

    case RESTORE_DYNAMICMETADATA:
      return {
        dynamicMetaDatas: payload.rows,
        totalCount: payload.count,
      };

    default:
      return state;
  }
};

export default dynamicMetaDataReducer;
